module.exports = __webpack_public_path__ + "static/img/plug4.6ee4c76c.png";